import { render } from "./ErrorBanner.vue?vue&type=template&id=13d20d53&scoped=true"
import script from "./ErrorBanner.vue?vue&type=script&lang=js"
export * from "./ErrorBanner.vue?vue&type=script&lang=js"

import "./ErrorBanner.vue?vue&type=style&index=0&id=13d20d53&scoped=true&lang=css"

import exportComponent from "/app/tmp/origina/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d20d53"]])

export default __exports__